/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MODERATOR" | "STAFF" | "%future added value";
export type ModerateStreamContainer_viewer = {
    readonly role: USER_ROLE;
    readonly " $refType": "ModerateStreamContainer_viewer";
};
export type ModerateStreamContainer_viewer$data = ModerateStreamContainer_viewer;
export type ModerateStreamContainer_viewer$key = {
    readonly " $data"?: ModerateStreamContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerateStreamContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerateStreamContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '3d68501c0457af243f8eb3968340434f';
export default node;
